import { async } from '@firebase/util';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { FirebaseHelper } from '../../firebase-helper';
import Image from '../Image/Image';
import LikeButtons from '../LikeButtons/LikeButtons';
import './PostCard.scss'

function PostCard(props) {

  const [post, setPost] = useState();

  useEffect(() => {
    setPost(props.post);
  })

  return (
    post &&

    <div key={post.id} className='post-card'>
      <a href={"post/" + post.id}>
        <div className='post-card-image-container'>
          {post.id && <Image path="PostImages" id={post.id} type="thumbnail" onClick={props.onClick} />}
        </div>
        <div className='post-card-content'>
          <h2>{post.title}</h2>
          <div className='like-buttons'>
            <LikeButtons id={post.id} type="posts" likes={post.likes} dislikes={post.dislikes} clickAble={false} />
          </div>
        </div>

      </a>

    </div>


  )
}

export default PostCard